import { TextField } from "@mui/material";
import PrioritySettingsTable, { ColumnType, DataType } from "./PrioritySettingsTable";

type Props = {
  data: DataType[];
  columns: ColumnType[];
  updateData: (rowIndex: number, colKey: string, value: number) => void;
};

export const makeColumnDef = (key: string): ColumnType => ({
  accessorKey: key.toLowerCase(),
  header: key,
  cell: ({ getValue, row, column, table }) => (
    <TextField
      variant="outlined"
      type="number"
      sx={{
        "& .MuiOutlinedInput-root": { "& fieldset": { borderColor: "transparent" } },
        "& .MuiOutlinedInput-input": { padding: "8px", textAlign: "center" },
        width: "6em",
      }}
      value={(getValue() as number) ?? 0}
      onChange={(e) =>
        table.options.meta?.updateData(row.index, column.id, parseFloat(e.target.value))
      }
    />
  ),
});

export const buildColumnsAndData = (
  rawSettings: Record<string, any>,
  parameters: { parameter: string; key: string; category: string }[],
): { cols: ColumnType[]; rows: DataType[] } => {
  const sortedKeys = Object.keys(rawSettings).sort(
    (a, b) => (rawSettings[a]?.baseTime ?? 0) - (rawSettings[b]?.baseTime ?? 0),
  );

  const cols: ColumnType[] = [
    { accessorKey: "parameter", header: "Parameter" },
    ...sortedKeys.map(makeColumnDef),
  ];

  const rows = parameters.map((param) => ({
    parameter: param.parameter,
    category: param.category,
    ...Object.fromEntries(
      sortedKeys.map((key) => {
        if (param.key.includes(".")) {
          const [mainKey, subKey] = param.key.split(".");
          return [key.toLowerCase(), rawSettings[key]?.[mainKey]?.[subKey] ?? 0];
        }
        return [key.toLowerCase(), rawSettings[key]?.[param.key] ?? 0];
      }),
    ),
  })) as DataType[];

  return { cols, rows };
};

const TimeTabView = ({ data, columns, updateData }: Props) => (
  <div style={{ padding: "0 1.5rem 1rem 1.5rem" }}>
    <PrioritySettingsTable data={data} columns={columns} updateData={updateData} />
  </div>
);

export default TimeTabView;
